import { styled } from '@mui/material/styles';
import { MaterialDesignContent } from 'notistack';

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-success': {
    backgroundColor: '#fff',
    color: '#333',
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: '#F88078',
  },
}));

export default StyledMaterialDesignContent;
